import { Component } from '@angular/core';

import { CensoService } from '@app/shared/services/censo.service';
import { MensagemService } from '@app/shared/services/mensagem.service';

import { environment } from '@environments/environment';
import { Loading, Censo } from '@app/shared/models';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent{

  carregar = new Loading();
  cliente = environment.cliente;

  censo: Censo;

  conteudoHTML: { nome: string, html: any }[] = [
    { nome: 'home', html: '' },
    { nome: 'documentacao', html: '' },
    { nome: 'header', html: '' },
    { nome: 'headerMobile', html: '' },
    { nome: 'homeSidebarHeader', html: '' },
    { nome: 'homeSidebarAposentados', html: '' },
    { nome: 'homeSidebarPensionistas', html: '' },
    { nome: 'homeSidebarDependentes', html: '' },
    { nome: 'homeSidebarAtivos', html: '' }
  ];

  constructor(
    private censoService: CensoService,
    private mensagemService: MensagemService,
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');
    this.buscarTexto();
  }

  redirecionar(): void {
    this.mensagemService.avisoMensagemAlerta(
      'Teremos uma interrupção temporária do nosso servidor com o objetivo de melhorar nossa estrutura. Agradecemos a compreensão de todos.',
      'AVISO DE MANUTENÇÃO'
    );
  }

  buscarTexto(): void {
    if(!this.censoService.retornarSessionStorage('sessaoConteudo')){
      this.conteudoHTML.forEach(item => {
        this.censoService.buscarTexto(this.cliente.censo_id, item.nome, this.carregar).subscribe(texto => {
          item.html = texto;
          this.censoService.salvarSessionStorage(item.nome, item.html);
        })
      })
      this.censoService.salvarSessionStorage('sessaoConteudo', true);
    }
  }

  retornarConteudoHTML(nomeConteudo: string): any {
    let conteudo = this.censoService.retornarSessionStorage(nomeConteudo);
    return (conteudo != '' && conteudo != ' ' && conteudo != null) ? conteudo : '';
  }
}
